<template src="./GrupoTipos.html"></template>
<script>
  import HttpUtil from '../../util/HttpUtil'
  import Mensajes from '../../util/Mensajes'
  import ManejaError from '../../util/ManejaError'

  export default {
    data () {
      let columna = 0
      let columnaTipo = 0
      return {
        clases: {
          loading: true
        },
        dtOptions: {
          endpoint: 'grupoTipos',
          columnDefs: [
            {title: 'Codigo', data: 'id', targets: columna++},
            {title: 'Nombre', data: 'nombre', targets: columna++}
          ]
        },
        dtOptionsTipos: {
          endpoint: 'tipos',
          columnDefs: [
            {title: 'Nombre', data: 'nombre', targets: columnaTipo++}
          ],
          ajax: {
            data: (data) => {
              data.grupo_id = this.grupoSeleccionado.id
            }
          }
        },
        accionesTipos: [{
          action: 'editar',
          name: '',
          tooltip: 'Editar',
          icon: 'large icon edit'
        }, {
          action: 'eliminar',
          name: '',
          tooltip: 'Eliminar',
          icon: 'large ico red delete'
        }],
        acciones: [{
          action: 'editar',
          name: '',
          tooltip: 'Editar',
          icon: 'large icon edit'
        }, {
          action: 'eliminar',
          name: '',
          tooltip: 'Eliminar',
          icon: 'large ico red delete'
        }],
        grupo: {},
        tipo: {},
        grupoSeleccionado: null,
        eliminarLoading: false,
        validacion: {
          error: false
        }

      }
    },
    mounted () {
      this.httpgrupoTipos = new HttpUtil('grupoTipos')
      this.httptipos = new HttpUtil('tipos')
    },
    methods: {
      showModal: function () {
        jQuery('#cegrupotipos').modal('show')
      },
      showEliminarModal: function () {
        jQuery('#elimgrupotipos').modal('show')
      },
      nuevo: function () {
        this.grupo = {}
        this.showModal()
      },
      nuevotipo: function () {
        this.tipo = {
          grupo_tipo_id: this.grupoSeleccionado.id
        }
        jQuery('#tipo').modal('show')
      },
      tipoGuardado: function () {
        this.tablaTipos && this.tablaTipos.draw(false)
      },
      dtAction: function (accion) {
        switch (accion.action) {
          case 'initComplete':
            this.clases.loading = false
            this.tabla = accion.table
            break
          case 'editar':
            this.grupo = jQuery.extend({}, accion.row.data()) // Debemos crear un nuevo obj para qur capture el evento del camio
            this.showModal()
            break
          case 'eliminar':
            this.grupo = (accion.row.data())
            this.showEliminarModal()
            break
          case 'rowSelected':
            if (accion.row === null) {
              this.grupoSeleccionado = null
            } else {
              this.grupoSeleccionado = accion.row.data()
              this.tablaTipos && this.tablaTipos.draw()
            }
            break
        }
      },
      grupotipoGuardada: function () {
        this.tabla.draw(false)
      },
      modalAction: function (action) {
        if (action.action === 'positive') {
          this.httpgrupoTipos.delete(this.grupo.id, this.manejaEliminaOk, this.manejaEliminaError)
        }
      },
      modalActiontipos: function (action) {
        if (action.action === 'positive') {
          this.httptipos.delete(this.tipo.id, this.manejaEliminaOkTipo, this.manejaEliminaErrorTipo)
        }
      },
      dtActionTipos: function (accion) {
        switch (accion.action) {
          case 'initComplete':
            this.tablaTipos = accion.table
            break
          case 'editar':
            this.tipo = jQuery.extend({}, accion.row.data())
            jQuery('#tipo').modal('show')
            break
          case 'eliminar':
            this.tipo = (accion.row.data())
            jQuery('#elimtipos').modal('show')
            break
        }
      },
      manejaEliminaError: function (response) {
        this.eliminarLoading = false
        this.validacion.error = true
        this.validacion.mensajes = ManejaError(response)
      },
      manejaEliminaOk: function (response) {
        this.validacion.error = false
        this.eliminarLoading = false
        jQuery('#elimgrupotipos').modal('hide')
        Mensajes.success('Grupo eliminado.')
        this.tabla.draw(false)
      },
      manejaEliminaErrorTipo: function (response) {
        this.eliminarLoading = false
        this.validacion.error = true
        this.validacion.mensajes = ManejaError(response)
      },
      manejaEliminaOkTipo: function (response) {
        this.validacion.error = false
        this.eliminarLoading = false
        jQuery('#elimtipos').modal('hide')
        Mensajes.success('tipo eliminado.')
        this.tablaTipos.draw(false)
      }
    },
    computed: {
      titulo: function () {
        return 'Eliminar Grupo: ' + this.grupo.nombre
      },
      mensaje: function () {
        return 'Está seguro que desea eliminar el grupo ' + this.grupo.nombre + '?'
      },
      titulotipo: function () {
        return 'Eliminar Tipo: ' + this.tipo.nombre
      },
      mensajetipo: function () {
        return 'Está seguro que desea eliminar el Tipo ' + this.tipo.nombre + '?'
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/GrupoTipos/GrupoTipos.vue